import { useLocalStorage } from "./useLocalStorage"

export const useVersioning = () => {
  const [version, setVersion] = useLocalStorage<string>("app_version", "1.0.0")

  const incrementVersion = () => {
    const [major, minor, patch] = version.split('.').map(Number)
    const newPatch = patch + 1
    const newVersion = `${major}.${minor}.${newPatch.toString().padStart(3, '0')}`
    setVersion(newVersion)
    return newVersion
  }

  const getVersion = () => version

  return {
    version,
    incrementVersion,
    getVersion
  }
}